const DebitPosTransactionTypes: any = {
  ALL: {
    description: 'All POS transactions',
    value: 'POS',
  },
  PIN: {
    description: 'PIN transactions only',
    value: 'POS_PIN',
  },
  SIGNATURE: {
    description: 'Signature transactions only',
    value: 'POS_SIGNATURE',
  },
};

export default DebitPosTransactionTypes;
